import { Component, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { groupByProperty } from '../../shared/utils/group-by-property';
import { EditableFieldsService } from '../editable-fields.service';
import { ReportRecord, ReportInfo } from '../../models/report.model';
@Component({
  selector: 'rep-presentation-dynamic-view',
  templateUrl: './presentation-dynamic-view.component.html',
  providers: [EditableFieldsService],
  standalone: false,
})
export class PresentationDynamicViewComponent extends AbstractDynamicReportViewComponent {
  recordNumber: number;
  recordsCount: number;
  reportRecordsData: ReportInfo;
  @Output() removeRecord: EventEmitter<ReportRecord> = new EventEmitter<ReportRecord>();
  @Output() reportReordered: EventEmitter<ReportRecord[]> = new EventEmitter<ReportRecord[]>();

  ngOnChanges({ columns, currentView, reportLocale, reportData }: SimpleChanges) {
    super.ngOnChanges({ columns, currentView, reportLocale, reportData });
    // TODO: Need to remove templateid check to groupby property records once receives groupby from BE "views/9/templates" API
    if (!!this.reportData && this.reportData.records && !!this.currentView && this.currentView.templateId === 16) {
      const groupRecordsByEntity = groupByProperty(this.reportData.records) as ReportRecord[];
      this.recordsCount = !!this.reportData && !!groupRecordsByEntity ? groupRecordsByEntity.length : null;
      this.reportRecordsData = { ...this.reportData, records: groupRecordsByEntity };
    } else if (!!this.currentView) {
      this.recordsCount = !!this.reportData && !!this.reportData.records ? this.reportData.records.length : null;
      this.reportRecordsData = this.reportData;
    }
  }

  navRecordNum(recordNumber: number) {
    this.recordNumber = recordNumber;
  }
}
